import { useContext, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './Profile.css';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import ProfileForm from './ProfileForm/ProfileForm';
import { PopupContext } from '../../../assets/contexts/popupContex';
import PreferencesList from '../../Auth/PreferencesPopup/PreferencesList/PreferencesList';
import { UserContext } from '../../../assets/contexts/userContext';
import AuthButton from '../../Auth/AuthButton/AuthButton';
import {
  PREFERENCES_POPUP_TYPE,
  MESSAGE_POPUP_TYPE,
} from '../../../assets/utils/constants';
import AccountsList from './AccountsList/AccountsList';
import PasswordForm from './PasswordForm/PasswordForm';
import ConfirmEmailBlock from '../ConfirmEmailBlock/ConfirmEmailBlock';
import mainApi from '../../../assets/api/MainApi';
import useAutoDismissError from '../../../assets/hooks/useAutoDismissError';
import useParseApiError from '../../../assets/hooks/useParseApiError';
import MessagePopup from '../../MessagePopup/MessagePopup';

function Profile() {
  const {
    desk: {
      profile: {
        details,
        accounts,
        preferences,
        changePreferences,
        password,
        notSetPasswordDetails,
        notSetPasswordOauth,
      },
    },
    auth: {
      recoveryPassword: { successText: resetPasswordText },
      resetPassword: { title: resetPasswordTitle },
    },
    helmet: { description, profileTitle },
  } = useContext(TranslationContext);
  const { user, setUser, getUser } = useContext(UserContext);
  const { handlePopupOpen } = useContext(PopupContext);
  const is_password_set = user?.reg_data?.is_password_set;
  const is_email_verified = user?.reg_data?.stages?.is_email_verified;
  const [isPreloader, setIsPreloader] = useState({});
  const [resetPasswordError, showResetPasswordError] = useAutoDismissError();
  const { parseApiError } = useParseApiError();

  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function resetPassword() {
    setIsPreloader((prev) => ({ ...prev, resetPassword: true }));
    mainApi
      .resetPasswordWithAuth()
      .then((res) => {
        setUser(res);
        handlePopupOpen(MESSAGE_POPUP_TYPE);
      })
      .catch((err) => {
        showResetPasswordError(parseApiError(err));
      })
      .finally(() => {
        setIsPreloader((prev) => ({ ...prev, resetPassword: false }));
      });
  }

  return (
    <section className="profile">
      <Helmet>
        <title>{profileTitle}</title>
        <meta name="description" content={description} />
      </Helmet>

      {user && (
        <>
          {!is_email_verified && <ConfirmEmailBlock />}

          <div className="profile__block">
            <h3 className="profile__title">{details}</h3>
            {!is_password_set && (
              <button
                className="profile__reset-btn"
                type="button"
                onClick={resetPassword}
              >
                <p className="profile__text profile__text_type_color">
                  {notSetPasswordDetails}
                </p>
              </button>
            )}
            <ProfileForm />
          </div>

          <div className="profile__block">
            <h3 className="profile__title">{password}</h3>
            <PasswordForm
              setIsPreloader={setIsPreloader}
              isPreloader={isPreloader}
              resetPassword={resetPassword}
              resetPasswordError={resetPasswordError}
            />
          </div>

          <div className="profile__block">
            <h3 className="profile__title">{preferences}</h3>
            {user?.personal_data?.category_ids?.length > 0 && (
              <PreferencesList data={user.personal_data.category_ids} isList />
            )}
            <div className="profile__btn-container">
              <AuthButton
                label={changePreferences}
                onClick={() => handlePopupOpen(PREFERENCES_POPUP_TYPE)}
              />
            </div>
          </div>

          <div className="profile__block">
            <h3 className="profile__title">{accounts}</h3>
            {!is_password_set && (
              <button
                className="profile__reset-btn"
                type="button"
                onClick={resetPassword}
              >
                <p className="profile__text profile__text_type_color">
                  {notSetPasswordOauth}
                </p>
              </button>
            )}
            <AccountsList />
          </div>
        </>
      )}

      <MessagePopup
        title={resetPasswordTitle}
        text={resetPasswordText}
        onClose={getUser}
      />
    </section>
  );
}

export default Profile;
